import { render } from "./VUEPage404.vue?vue&type=template&id=30d5b281"
import script from "./VUEPage404.vue?vue&type=script&lang=js"
export * from "./VUEPage404.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__